<template>
  <div>
    <div 
      class="absolute min-h-full z-40 md:flex md:flex-row md:relative"
      :class="{ 'hidden md:flex md:flex-row': isAsideBarHidden }"
    >
    <div class="flex flex-shrink-0 h-full min-h-screen">
      <transition name="fade" mode="out-in">
          <div class="flex flex-col h-full min-h-screen w-18">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex flex-col h-0 flex-1 bg-secondary-darker">
              <div class="flex-1 flex flex-col">
                <div class="md:hidden text-secondary-invert flex justify-center items-center h-16">
                  <span class="cursor-pointer" @click="closeLeftSidebar()">
                    <ArrowLeft class="w-5" />
                  </span>
                </div>
                <hr class="md:hidden mx-4 border-t border-secondary-light" />

                <nav-dropdown :logo="logo" />
                <hr class="mx-4 border-t border-secondary-light" />

                <div
                  :id="origin == 'Groove.cm' ? 'no_fill_sidebar' : 'left_sidebar'"
                  class="flex-1 flex flex-col overflow-y-auto"
                >
                  <nav
                    aria-label="Sidebar"
                    class="
                      md:block
                      md:flex-shrink-0
                      md:bg-secondary-darker
                      md:overflow-y-auto
                      h-full
                      justify-between
                      flex flex-col
                    "
                  >
                    <div class="w-18 flex flex-col p-3 space-y-3 items-center">
                      <div
                        v-for="slot in slots"
                        v-show="slot.icon"
                        :id="slot.id"
                        :key="slot.name"
                        class="
                          hover:bg-secondary
                          flex-shrink-0
                          inline-flex
                          items-center
                          justify-center
                          h-10
                          w-10
                          rounded-lg
                          mx-auto
                          relative
                          text-secondary-invert
                          sideBar-item
                        "
                        :class="[
                          {
                            activeSideBar: openSection === slot.name,
                            'text-secondary-invert': openSection != slot.name,
                            'cursor-pointer':
                              !slot.disableForMegamenu || !isMegamenuEditing,
                            'cursor-not-allowed pointer-events-none':
                              slot.disableForMegamenu && isMegamenuEditing
                          },
                          slot.name.toLowerCase().replaceAll(' ', '')
                        ]"
                        @click.stop="setOpen(slot.name)"
                        v-tooltip="{
                          content: slot.new ?
                            `${slot.name} <span class='text-primary ml-2'>${$t('frontend_new')}</span>` :
                            slot.name,
                          placement: 'right',
                          classes: ['sidebar-tooltip']
                        }"
                      >
                        <component :is="slot.icon" class="h-5 w-5" />
                        <span
                          v-if="slot.label && slot.label !== ''"
                          class="iconLabel"
                          >{{ slot.label }}</span
                        >
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
              <div class="flex-shrink-0 flex pb-5">
                <div class="flex-1 flex flex-col overflow-y-auto">
                  <nav
                    aria-label="Sidebar"
                    class="
                      md:block
                      md:flex-shrink-0
                      md:bg-secondary-darker
                      md:overflow-y-auto
                      h-full
                      justify-between
                      flex flex-col
                    "
                  >
                    <div class="w-18 flex flex-col p-3 space-y-3 items-center">
                      <LanguageSelector />
                      <div
                        v-for="(slot, index) in nativeMenus"
                        v-show="slot.icon"
                        :id="index"
                        :key="slot.name"
                        class="
                          cursor-pointer
                          hover:bg-secondary
                          hover:text-primary
                          flex-shrink-0
                          inline-flex
                          items-center
                          justify-center
                          h-10
                          w-10
                          rounded-lg
                          text-secondary-invert
                          sideBar-item
                        "
                        :class="[
                          { activeSideBar: openSection === slot.name },
                          slot.name.toLowerCase().replaceAll(' ', '')
                        ]"
                        @click.stop="setOpen(slot.name, true)"
                        v-tooltip="{
                          content: slot.name,
                          placement: 'right',
                          classes: ['sidebar-tooltip']
                        }"
                      >
                        <component :is="slot.icon" class="h-6 w-6" />
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      
      <div class="bg-secondary flex flex-col absolute top-0 left-full z-20 md:relative md:left-0">
        <transition name="fade" mode="out-in">
          <div v-for="section in openSections" :key="section.name">
            <div
              v-if="section.doNotOpen !== 1"
              :class="{ 'h-full min-h-screen w-80': !double, 'w-160': double }"
            >
              <div
                class="
                  heading
                  border-solid border-secondary-light border-b
                  flex flex-row
                  justify-between
                  h-16
                  px-5
                "
              >
                <div v-if="isBlock" class="flex flex-column items-center z-10 hover:text-primary cursor-pointer">
                  <span v-if="!renamingBlock"
                    >{{ customTitle || section.title || section.name }}
                    <span
                      class="rename-block"
                      v-if="isBlock"
                      @click="renameBlock()"
                      ><edit-icon class="h-4 w-4"></edit-icon></span
                  ></span>
                  <span class="flex flex-grow" v-else
                    ><input
                      class="rename-block-title"
                      type="text"
                      v-model="inputTitle"/>
                    <span class="rename-block" @click="saveRenameBlock()"
                      ><check-icon class="h-4 w-4"></check-icon></span
                  ></span>
                </div>
                <div v-else class="flex flex-column items-center z-10">
                  <slot name="header"></slot>
                </div>
                <div class="flex flex-column items-center hover:text-primary cursor-pointer">
                  <slot :name="section.slot + '_header'"></slot>
                  <back-icon
                    v-if="closeIcon === 'BackIcon'"
                    class="h-4 w-4"
                    @click="close()"
                  />
                  <menu-close-icon v-else @click="close()" />
                </div>
              </div>
              <hr class="border-t border-secondary-light" />
              <div
                v-if="showSubTitle"
                class="text-secondary-invert opacity-75 text-xs font-bold px-4 mt-6 uppercase"
              >
                {{ section.name }}
              </div>
              <div
                style="max-height: calc(100vh - 65px);"
                class="
                  overflow-y-auto
                  flex flex-col flex-grow
                  custom-scrollbars
                  text-sm
                "
              >
                <slot v-if="section.slot" :name="section.slot"></slot>
                <component :is="section.component" v-if="section.component" />
              </div>
            </div>
          </div>
        </transition>
      </div>
      <transition name="fade" mode="out-in">
        <side-bar-left v-if="menuOpenLeft" @closeSideBar="showCloseSideBar" />
      </transition>
    </div>
    <portal to="headerBreadCrumb">
      <Button @click="openLeftSidebar()" overrideClass="md:hidden rounded-sm border-black h-7 w-7" size="icon">
        <MenuBurger class="w-5" />
      </Button>
    </portal>
  </div>
</template>

<script>
import directives from '../directives';
import AcademyMenu from './AcademyMenu';
import FeedbackMenu from './FeedbackMenu';
import LanguageSelector from './LanguageSelector';
import MultiLevelDropdown from './MultiLevelDropdown';
import NavDropdown from './NavDropdown';
import SideBarLeft from './SideBarLeft';
import SupportMenu from './SupportMenu';
import Button from './Button';

// import icons
import AcademyIcon from '../assets/academy-icon.svg';
import BackIcon from '../assets/arrow.svg';
import CheckIcon from '../assets/check-icon.svg';
import CloseIcon from '../assets/close-icon.svg';
import FeedbackIcon from '../assets/feedback-icon.svg';
import GrooveAffiliateLogo from '../assets/grooveaffiliate-logo-small.svg';
import GrooveBlogLogo from '../assets/grooveblog-logo-small.svg';
import GrooveKartLogo from '../assets/groovekart-logo-small.svg';
import GrooveMailLogo from '../assets/groovemail-logo-small.svg';
import GrooveMemberLogo from '../assets/groovemember-logo-small.svg';
import GroovePagesLogo from '../assets/groovepages-logo-small.svg';
import GrooveSellLogo from '../assets/groovesell-logo-small.svg';
import GrooveVideoLogo from '../assets/groovevideo-logo-small.svg';
import GrooveWebinarLogo from '../assets/groovewebinar-logo-small.svg';
import GdLogo from '../assets/logo-extra-small.svg';
import MenuCloseIcon from '../assets/menu-close-icon.svg';
import EditIcon from '../assets/pencil.svg';
import SupportIcon from '../assets/support-icon.svg';
import MenuBurger from '../assets/icons/menu-burger.svg';
import ArrowLeft from '../assets/arrow-left.svg';

export default {
  name: 'SideBar',
  directives,
  components: {
    Button,
    NavDropdown,
    CloseIcon,
    MultiLevelDropdown,
    MenuCloseIcon,
    EditIcon,
    CheckIcon,
    SideBarLeft,
    FeedbackIcon,
    FeedbackMenu,
    BackIcon,
    AcademyIcon,
    AcademyMenu,
    SupportIcon,
    SupportMenu,
    GroovePagesLogo,
    GrooveSellLogo,
    GrooveAffiliateLogo,
    GrooveMailLogo,
    GrooveMemberLogo,
    GrooveVideoLogo,
    GrooveBlogLogo,
    GrooveWebinarLogo,
    GrooveKartLogo,
    GdLogo,
    LanguageSelector,
    MenuBurger,
    ArrowLeft
  },
  props: {
    closeIcon: {
      default: 'CloseIcon'
    },
    initialOpen: {},
    sections: {},
    title: {},
    double: {},
    fixed: {},
    noExitButton: { default: false },
    isBlock: { default: false },
    noContent: { default: false },
    editBlockTitle: {},
    componentId: {},
    origin: { default: 'GroovePages' },
    logo: {},
    showSubTitle: { default: true },
    clickEnable: { default: false },
  },
  data() {
    return {
      isAsideBarHidden: true,
      hoveredCategory: '',
      hoveredApps: [],
      showChildSidebar: false,
      openSection: null,
      slots: [],
      menuOpenLeft: false,
      renamingBlock: false,
      inputTitle: '',
      nativeMenus: [
        {
          name: this.$t('frontend_sites_side_bar_section_groovedigital_academy'),
          icon: AcademyIcon,
          component: AcademyMenu
        },
        {
          name: this.$t('frontend_sites_side_bar_left_heldesk'),
          icon: SupportIcon,
          component: SupportMenu
        },
        {
          name: this.$t('frontend_feedback'),
          icon: FeedbackIcon,
          component: FeedbackMenu
        }
      ]
    };
  },
  computed: {
    multiSection() {
      return Array.isArray(this.sections);
    },
    openSections() {
      return [...this.slots, ...this.nativeMenus].filter(
        section => section.name === this.openSection
      );
    },
    customTitle() {
      return this.inputTitle || this.title;
    },
    correctedOpenSection() {
      if (this.openSection === 'Edit Popup') return 'Popups';

      return this.openSection;
    },
    modified() {
      return this.$store.state?.builder?.modified;
    },
    isMegamenuEditing() {
      return this.$store.getters['megamenu/isMegamenuEditing'];
    },
  },
  watch: {
    title: {
      deep: true,
      handler(newValue, oldValue) {
        this.renamingBlock = false;
        if (oldValue !== newValue) this.inputTitle = newValue;
      }
    },
    componentId: {
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue !== newValue) this.renamingBlock = false;
      }
    },
    sections: {
      deep: true,
      immediate: true,
      handler() {
        if (this.multiSection) {
          this.slots = this.sections.map(section => ({
            ...section,
            slot: section.name
          }));
        } else {
          this.slots = [{ name: this.sections, slot: 'default' }];
        }
      }
    }
  },
  created() {
    if (this.multiSection && this.initialOpen) {
      const openSectionObject = this.slots.find(
        slot => slot.name === this.initialOpen
      );

      this.openSection = this.initialOpen;
    } else if (typeof this.initialOpen !== 'undefined') {
      this.openSection = this.sections[0].name;
    }
  },
  methods: {
    hideAllDropdowns(resolve) {
      for (let i = 0; i < 10; i++) {
        if (this.$refs[`ml_dropdown_${i}`]) {
          this.$refs[`ml_dropdown_${i}`].isHidden = true;
        }
      }
      resolve(); // don't forget call resolve!
    },

    setOpen(name, isNativeMenu = false) {
      let openSectionEnable = false;
      if (this.correctedOpenSection !== name) {
        const openSectionObject = this.slots.find(slot => slot.name === name);

        this.openSection = null;

        if (!this.noContent || isNativeMenu) this.openSection = name;

        if (name === 'Pages' && this.isMegamenuEditing) {
          this.openSection = this.$t(
            'frontend_builder_elements_menu_edit_megamenu'
          );
          name = this.$t('frontend_builder_elements_menu_edit_megamenu');
        }
        openSectionEnable = true;
      }
    //to make click enable when clickEnable is true
     if(openSectionEnable || this.clickEnable) {
        this.$nextTick(() => {
          this.$emit('open', name);
        });
      }
    },
    close() {
      const toClose = this.openSection;
      if (!this.openSection) return;
      this.openSection = null;
      this.renamingBlock = false;
      this.$nextTick(() => {
        this.$emit('close', toClose);
      });
    },
    open() {
      if (this.initialOpen) this.openSection = this.initialOpen;
      else if (this.multiSection) this.openSection = this.sections[0];
      else this.openSection = this.sections;
      this.$nextTick(() => {
        this.$emit('open', this.openSection);
      });
    },
    openLeftSidebar() {
      this.menuOpenLeft = true;
      this.openSection = null;
    },
    exit() {
      window.location.replace('/');
    },
    showCloseSideBar(payload) {
      this.menuOpenLeft = payload;
    },
    onMouseOver(name) {
      /** */
    },
    onMouseLeave(name) {
      /** */
    },
    renameBlock() {
      this.renamingBlock = true;
    },
    saveRenameBlock() {
      this.renamingBlock = false;
      this.$emit('editBlockTitle', this.inputTitle);
    },
    handleRedirect(e, url, target) {
      if (this.modified && target === '_self') {
        this.$store.commit('setRedirect', url);
        e.preventDefault();
      }
    },
    // to make click enable when clickEnable is true
    openLeftSidebar() {
      this.isAsideBarHidden = false;
    },
    closeLeftSidebar() {
      this.isAsideBarHidden = true;
    },
  }
};
</script>

<style scoped>
.defaultSideBarItem {
  background-color: var(--brand-secondary-darker);
  fill: var(--brand-primary, #fd6481);
  stroke: var(--brand-primary, #fd6481);
}
.defaultSideBarItem > svg > g > path,
.defaultSideBarItem > svg > g > ellipse,
.defaultSideBarItem > svg > g > rect {
  stroke: var(--brand-primary, #fd6481);
}
.defaultSideBarItem.settings > svg path {
  fill: var(--brand-primary, #fd6481);
}
.defaultSideBarItem > svg > g > ellipse {
  fill: var(--brand-primary, #fd6481);
}

.sideBar {
  fill: rgba(164, 168, 192, var(--tw-text-opacity));
}

/* custom hover style for sidebar item */
.sideBar-item {
  transition: all 0.2s ease-in-out
}

.activeSideBarMail,
.sideBar-item:hover { 
  color: var(--brand-primary);
  transform: scale(1.07);
}


.activeSideBar {
  background-color: var(--brand-secondary-darker);
  fill: var(--brand-primary);
  stroke: var(--brand-primary);
  color: var(--brand-primary);
}
.activeSideBar > svg > g > path,
.activeSideBar > svg > g > ellipse,
.activeSideBar > svg > g > rect {
  stroke: var(--brand-primary);
}

.activeSideBar.settings > svg path {
  fill: var(--brand-primary);
}
.feedBackActive > svg > g > path:first-child {
  fill: var(--brand-primary);
}
.activeSideBar > svg > g > ellipse {
  fill: var(--brand-primary);
}
.rename-block {
  display: inline-block;
  cursor: pointer;
  margin-left: 10px;
  position: relative;
  top: 4px;
}
.rename-block-title {
  background-color: var(--brand-secondary-darker);
  color: var(--brand-secondary-invert);
  font-weight: bold;
  outline: none;
}
.rename-block-title:focus {
  border-bottom: 1px solid var(--brand-secondary-invert);
}
</style>
<style lang="scss">
.tooltip.sidebar-tooltip {
  display: block !important;
  z-index: 10000;
  margin-left: 70px !important;
  .tooltip-inner {
    background: var(--brand-secondary-darker) !important;
    font-weight: 600;
    color: var(--brand-secondary-invert);
    border-radius: 8px;
    padding: 5px 20px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: var(--brand-secondary-darker);
  }
  &[x-placement^='left'] {
    margin-left: 5px;
  }
  &[x-placement^='left'] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    border-right-color: var(--brand-secondary-darker) !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
span.iconLabel {
  position: absolute;
  top: -3px;
  right: -11px;
  background-color: var(--brand-primary);
  color: var(--brand-primary-invert);
  font-size: 9px;
  padding: 3px 3px 1px;
  line-height: 9px;
  border-radius: 10px;
}
</style>
